import { UndersideList } from 'ui/components';

export const UndersideListFeature: React.FC<Content.UndersideList> = ({ content }) => {

	return <UndersideList {...content?.properties} />;
};
